import {LocaleMessagesByLocales, LanguagesPackage} from '../types';

const LocaleUtils = {
  // TODO: locales merge with BE request when available
  wrapLanguageMessages(localeFiles: LanguagesPackage): LocaleMessagesByLocales {
    let result = <LocaleMessagesByLocales>{};
    if (localeFiles) {
      localeFiles.forEach((languagePackage) => {
        result = {
          ...result,
          [languagePackage.locale]: languagePackage.messages,
        };
      });
    }
    return result;
  },

  detectUserLanguage(supportedLanguages: string[], fallback = 'en'): string {
    const languages = navigator.languages || [navigator.language];
    // console.log('languages detected', languages);
    const match = languages.find((lang) => supportedLanguages.includes(lang.split('-')[0]));
    return match ? match.split('-')[0] : fallback;
  },

  detectAndUpdateConfigPreferredLanguage(
    i18nConfigJson: any,
    supportedLanguages: string[],
    preferredLanguageUpdater: (detectedLanguage: string, configJson: any) => void,
    fallbackLanguage: string | undefined = 'en'
  ) {
    const configCopy = JSON.parse(JSON.stringify(i18nConfigJson));
    const userLanguage = this.detectUserLanguage(supportedLanguages, fallbackLanguage);
    preferredLanguageUpdater(userLanguage, configCopy);

    // console.log('thunk language: ', configCopy.config.languages.preferredLanguage);
    return configCopy;
  },
};

export default LocaleUtils;
